import { render } from "./ActivatePage.vue?vue&type=template&id=85f1007c"
import script from "./ActivatePage.vue?vue&type=script&lang=js"
export * from "./ActivatePage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__